import { StyleSheet } from 'react-native';
import { PALETTE } from '../../../constants';

export default StyleSheet.create({
  root: {
    display: 'flex',
    margin: 10,
  },
  rootCustom: {
    marginBottom: 0,
  },
  title: {
    textAlign: 'center',
    marginTop: 1,
    marginBottom: 8,
  },
  titleCustom: {
    marginBottom: 0,
  },
  otherPeriodsText: {
    textAlign: 'center',
    marginBottom: 10,
  },
  otherPeriodsList: {
    borderColor: PALETTE.primaryStrokeLine,
    borderWidth: 1,
    paddingVertical: 9,
  },
  otherPeriod: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 27,
  },
  otherPeriodBullet: {
    backgroundColor: 'transparent',
    color: PALETTE.secondaryText,
    fontSize: 13,
    paddingRight: 5,
  },
  otherPeriodText: {
    display: 'flex',
    margin: 4,
  },
  otherPeriodArrow: {
    paddingRight: 1,
  },
});
